import React from 'react'
import ConsultingForm from '../ConsultingForm/ConsultingForm';

const Consultinencey = (props) => {
    return (
        <section className={`contact-section ${props.contactClass}`}>
            <div className="content-area clearfix">
                <div className="contact-info-col">
                    <div className="contact-info">
                        <ul>
                            <li>
                                <i className="fi flaticon-home-3"></i>
                                <h4>Head Office</h4>
                                <p>123 Demo Street</p>
                            </li>
                            <li>
                                <i className="fi flaticon-email"></i>
                                <h4>Email Address</h4>
                                <p>demo@example.com</p>
                            </li>
                            <li>
                                <i className="fi flaticon-support"></i>
                                <h4>Telephone</h4>
                                <p>(123) 456-7890</p>
                            </li>
                            <li>
                                <i className="fi flaticon-clock"></i>
                                <h4>Office Hours</h4>
                                <p>Mon-Sun: 10am – 7pm</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="contact-form-col">
                    <div className="section-title-s2">
                        <div className="icon">
                            <i className="fi flaticon-balance"></i>
                        </div>
                        <span>Contact form</span>
                        <h2>Request A Free Quote</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>

                    <div className="contact-form">
                        <ConsultingForm />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Consultinencey;